import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { StockOperation } from '../models/stock-operation.model';
import { ProductStockLevel } from '../models/product-stock-level.model';

@Injectable({
  providedIn: 'root'
})
export class StockService {

  /**
  * Endpoint for http calls
  */
  private _endpoint: string = environment.api.endpoint;

  constructor(private httpClient: HttpClient) { }

  goodsIn(operation: StockOperation): Observable<ProductStockLevel[]> {
    return this.postOperation('goods-in', operation);
  }

  goodsOut(operation: StockOperation): Observable<ProductStockLevel[]> {
    return this.postOperation('goods-out', operation);
  }

  transfer(operation: StockOperation): Observable<ProductStockLevel[]> {
    return this.postOperation('transfer', operation);
  }

  adjustment(operation: StockOperation): Observable<ProductStockLevel[]> {
    return this.postOperation('adjustment', operation);
  }

  getStockLevelsForProduct(productId: number): Observable<ProductStockLevel[]> {

    if (!productId || productId === -1) {
      throw new Error('You must supply a valid id in getStockLevelsForProduct');
    }

    return this.httpClient.get(this._endpoint + 'product-stock-level?filter=productId||eq||' + productId
      + '&join=warehouseLocation&join=warehouseLocation.warehouse').pipe(map((data) => {
        return <ProductStockLevel[]>data;
      }));
  }

  /**
   * The backend runs each operation as a single transaction, so the whole batch of
   * lines goes up in one request. Posting line by line would allow a partial post.
   *
   * @param action endpoint suffix for the operation being posted
   * @param operation referenceId plus the lines to post
   *
   * @returns Observable<ProductStockLevel[]> resulting stock levels
   */
  private postOperation(action: string, operation: StockOperation): Observable<ProductStockLevel[]> {

    if (!operation) {
      throw new Error('stock service: you must supply an operation object for saving');
    }

    if (!operation.lines || operation.lines.length === 0) {
      throw new Error('stock service: an operation must have at least one line');
    }

    return this.httpClient.post(this._endpoint + 'product-stock-movement/' + action,
      JSON.stringify(operation),
      { headers: { 'Content-Type': 'application/json' } }).pipe(map((data) => {
        return <ProductStockLevel[]>data;
      }));
  }
}
